import React from "react";
import Box from "../shortcodes/box";
import rehypeReact from "rehype-react";

export default new rehypeReact({
  createElement: React.createElement,
  components: { box: Box }
}).Compiler;
